import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { ProposalService } from 'src/app/_services/proposal.service';
import { InsuranceMetadatas, Lead } from 'src/app/_types/lead.types';
import { COUNTRIES } from 'src/app/helpers/nationalities';
import { environment } from 'src/environments/environment';

@Directive()
export class BaseMetadataComponent<T> implements OnInit {
  @Input()
  metadata!: T;

  @Input()
  baseMetadata!: InsuranceMetadatas;

  @Input()
  originalLeadId?: string;

  @Input()
  originalLead?: Lead;

  @HostBinding('class.cards-container') cardsContainer: boolean = true;

  @HostBinding('class.d-flex') dBlock = true;

  @HostBinding('class.flex-column') flexColumn = true;

  originalMetadata!: T;

  DATE_FORMAT = environment.DATE_FORMAT;

  nationalities = COUNTRIES;

  constructor(protected readonly proposalService: ProposalService) {}

  ngOnInit(): void {
    if (this.baseMetadata) {
      this.metadata = this.baseMetadata as T;
    }
    if (this.originalLead) {
      this.originalMetadata = this.originalLead.metadata as T;
    } else if (this.originalLeadId) {
      this.proposalService
        ._getPartnerLeadDetails({ leadId: this.originalLeadId })
        .subscribe({
          next: (res) => {
            if (res.data?.metadata) {
              this.originalMetadata = res.data.metadata as T;
            }
          },
        });
    }
  }
}
